function parseJsonString(value) {
  if (typeof value !== "string") {
    return value;
  }

  const trimmed = value.trim();
  if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) {
    return value;
  }

  try {
    return JSON.parse(trimmed);
  } catch (error) {
    return value;
  }
}

function messageFromPayload(payload) {
  const data = parseJsonString(payload);

  if (data == null || data === "") {
    return null;
  }

  if (typeof data === "string") {
    const nested = parseJsonString(data);
    if (nested !== data) {
      return messageFromPayload(nested);
    }

    return data.trim() || null;
  }

  if (Array.isArray(data)) {
    return data.find(Boolean) != null ? String(data.find(Boolean)) : null;
  }

  if (typeof data === "object") {
    if (Array.isArray(data.messages) && data.messages.length > 0) {
      return String(data.messages.find(Boolean));
    }

    if (typeof data.messages === "string" && data.messages.trim()) {
      return messageFromPayload(data.messages);
    }

    if (data.message != null && data.message !== "") {
      return String(data.message);
    }

    if (data.Message != null && data.Message !== "") {
      return String(data.Message);
    }

    if (data.return != null && data.return !== "") {
      return String(data.return);
    }

    if (data.title != null && data.title !== "") {
      return String(data.title);
    }
  }

  return null;
}

export function extractApiErrorMessage(error, fallback = "Beklenmeyen bir hata oluştu.") {
  if (!error) {
    return fallback;
  }

  const candidates = [
    error?.response?.data,
    error?.data,
    error,
  ];

  for (const candidate of candidates) {
    const message = messageFromPayload(candidate);
    if (message) {
      return message;
    }
  }

  if (typeof error === "string" && error.trim()) {
    return error.trim();
  }

  if (error?.message && error.message !== "Network Error") {
    return String(error.message);
  }

  return fallback;
}

export function getApiBusinessErrorMessage(payload) {
  const data = parseJsonString(payload);

  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return null;
  }

  const responseCode = data.responseCode;
  const isSuccess =
    responseCode === 200 ||
    responseCode === "200" ||
    responseCode === "OK" ||
    responseCode == null;

  if (isSuccess) {
    return null;
  }

  return messageFromPayload(data);
}
